// @flow
import React, { Component } from "react";
import logo from "./images/img.png";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import { createStructuredSelector } from "reselect";
import moment from 'moment';
import "./styles.css";
import {
  makeSelectData,
  makeSelectTransfers,
  makeSelectMoney,
  makeSelectOptions,
  makeSelectLoading,
  makeSelectError,
  makeSelectInfo
} from "../QuotePage/selectors";
import {
  fetchBasketData,
  postBasketData,
  changeBasketCurrency
} from "../../actions/basket";
import {
  fetchHelpData,
  fetchSeatTypesData,
  fetchChildAgesData
} from "../../actions/info";
import { change } from "redux-form";

type Props = {
  fetchBasketData: Function,
  postBasketData: Function,
  changeBasketCurrency: Function,
  basketData: any,
  initialInboundValues: any,
  onSelect: Function,
  match: Object,
  transfers: Object,
  loading: boolean,
  options: Object,
  money: Object,
  error: boolean
};

class Header extends Component<Props, State> {
  state: State;
  constructor() {
    super();
    this.state = {
      from: [null, null],
      to: [null, null],
      date: [null, null],
      adults: [0, 0],
      children: [0, 0],
      infants: [0, 0],
      retunTrip: false
    };
  }
  setChildren = d => {
    const dist = d === "out" ? 0 : 1;
    let infants = 0;
    let children = 0;
    if (this.props.basketData.transfers[dist].children.length > 0) {
      this.props.basketData.transfers[dist].children.map(child => {
        if (
          (child.seatType.code === "BABY" && child.age <= 2) ||
          (child.age <= 2 && child.age != null)
        ) {
          infants++;
        } else {
          children++;
        }
        return true;
      });
      dist === 0
        ? this.setState({ infants: [infants, this.state.infants[1]] })
        : this.setState({ infants: [this.state.infants[0], infants] });
      dist === 0
        ? this.setState({ children: [children, this.state.children[1]] })
        : this.setState({ children: [this.state.children[0], children] });
    }
  };
  componentDidUpdate(prevProps) {
    if (prevProps.basketData !== this.props.basketData) {
      if (this.props.basketData.transfers) {
        this.setState({
          retunTrip: this.props.basketData.transfers[1] ? true : false
        });

        this.setState({
          from: [
            this.props.basketData.transfers[0].fromDestination.name,
            this.state.from[1]
          ],
          to: [
            this.props.basketData.transfers[0].toDestination.name,
            this.state.to[1]
          ],
          date: [
            `${moment(this.props.basketData.transfers[0].date).format('Do MMM YYYY')} at ${this.props.basketData.transfers[0].time} `,
            this.state.date[1]
          ],
          adults: [
            this.props.basketData.transfers[0].adults,
            this.state.adults[1]
          ],
          infants: [0, this.state.infants[1]],
          children: [0, this.state.children[1]]
        });
        this.setChildren("out");

        if (this.state.retunTrip) {
          this.setState({
            from: [
              this.state.from[0],
              this.props.basketData.transfers[1].fromDestination.name
            ],
            to: [
              this.state.to[0],
              this.props.basketData.transfers[1].toDestination.name
            ],
            date: [
              this.state.date[0],
              `${moment(this.props.basketData.transfers[1].date).format('Do MMM YYYY')} at ${this.props.basketData.transfers[1].time} `
            ],
            adults: [
              this.state.adults[0],
              this.props.basketData.transfers[1].adults
            ],
            infants: [this.state.infants[0], 0],
            children: [this.state.children[0], 0]
          });
          this.setChildren("in");
        }
      }
    }
  }
  getSummary = () => {
    return ( 
      <div className="summary-pannel container">
        <h4><strong>Your Search</strong></h4>
        {this.getbound("out")}
        <div className="change-section"><span>{this.state.retunTrip && <hr/>}</span><div className="change-options">
              <a href="https://www.ski-lifts.com" className="btn"><span>Change</span></a>
          </div></div>
        {this.state.retunTrip && this.getbound("in")}
      </div>
    );
  };
  getbound = d => {
    const dist = d === "out" ? 0 : 1;
    return (
      <div className="one-bound">
        <strong>{d}bound:   </strong>
            {this.state.from[dist]} to {this.state.to[dist]} on the {this.state.date[dist]}
           {`for ${this.state.adults[dist]} adult${this.state.adults[0] > 1 ? "s" : ""}`}
          {this.state.children[dist] > 0 &&
            `${this.state.infants[dist] < 1 ? " &" :","} ${this.state.children[dist]} child${(this.state.children[dist] > 1) ? "ren" : ""} `}
          { this.state.infants[dist] > 0 && ` ${this.state.infants[dist] > 0 ? "&" : ""} ${this.state.infants[dist]} Infant${this.state.infants[dist] > 1 ? "s" : ""}`}
      </div>
    );
  };

  render() {
    return (
      <div>
          <header id="masthead" className="site-header" role="banner">
            <div className="main-menu-wrapper">
              <div className="main-resposive-menu">
                <div id="logo" className="logo">
                  <a href="/" rel="home">
                    <img src={logo}
                         alt="airport transfers to ski resorts" width="" height="51"/>
                  </a>
                </div>
              </div> 
            </div>
          </header>
       { window.location.href.includes("quote") && !window.location.href.includes("stp3") && (<div className="summary-wrapper">
          <input type="checkbox" className="details-toggle" />
          <span className="details-toggle-title" />
          {this.getSummary()}
        </div>)}
      </div>
    );
  }
}

const mapStateToProps = createStructuredSelector({
  basketData: makeSelectData(),
  transfers: makeSelectTransfers(),
  money: makeSelectMoney(),
  options: makeSelectOptions(),
  loading: makeSelectLoading(),
  error: makeSelectError(),
  info: makeSelectInfo()
});

export default withRouter(
  connect(mapStateToProps, {
    fetchBasketData,
    postBasketData,
    changeBasketCurrency,
    fetchHelpData,
    change,
    fetchSeatTypesData,
    fetchChildAgesData
  })(Header)
);



// WEBPACK FOOTER //
// ./src/containers/Header/index.js